import { render, staticRenderFns } from "./SellerComissionCardsView.vue?vue&type=template&id=69836316&scoped=true"
import script from "./SellerComissionCardsView.vue?vue&type=script&lang=js"
export * from "./SellerComissionCardsView.vue?vue&type=script&lang=js"
import style0 from "./SellerComissionCardsView.vue?vue&type=style&index=0&id=69836316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69836316",
  null
  
)

export default component.exports